export default __webpack_public_path__ + "static/topNavItems-dont-2-dark-c6e46b5494e95fe74e54d4f5fe04c5d8.png";